import axios from 'axios';
import { API_BASE_URL } from '../config/secrets.json';

const getUrl = endpoint => `${API_BASE_URL}${endpoint}`;

export const post = async(endpoint, data) => {
	return axios.post(getUrl(endpoint), data, {
		headers: {
			"Content-Type": "application/json",
		},
	});
};

export const get = async(endpoint, jwt) => {
	const headers = jwt
	? {
		headers: {
			Authorization: `Bearer ${jwt}`,
		}
	} : null;
	return axios.get(getUrl(endpoint), headers);
};

export const postWithToken = async(endpoint, data, jwt) => {
	return axios.post(getUrl(endpoint), data, {
		headers: {
			'Authorization': `Bearer ${jwt}`
		},
	});
};

export const getData = (endpoint, jwt) => {
	try {
		return get(endpoint, jwt);
	} catch (error) {
		return error;
	}
};



// WEBPACK FOOTER //
// ./src/lib/request.js